'use client'

import useTabs from '../hooks/useTabs'
import { useHomeContext } from '../HomeProvider'

const SellerPromotionWrapper = ({ children }: { children: React.ReactNode }) => {
  const { isLoading } = useHomeContext()
  const { currentTab } = useTabs()

  if (!currentTab.isSellerPromotionEnabled) return null
  if (isLoading) return null

  return children
}

export default SellerPromotionWrapper
